// ------------ A C U E R D O S    I T E ------------
export const dataAcuerdos2025 = [
  {
    id: 1,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE REDECUA DISTRIBUCIÓN DE PRERROGATIVAS A PP.",
    titleAnexo1: "FINANCIAMIENTO PUBLICO ANUAL.",
    titleAnexo2: "FINANCIAMIENTO PUB ACT ESPECÍFICAS.",
  },
  {
    id: 2,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "ACTUALIZACIÓN Y CALENDARIZACIÓN DE MULTAS PP.",
    titleAnexo1: "ACTUALIZACIÓN CALENDARIZACIÓN SANCIONES.",
    titleAnexo2: "CALENDARIZADO DE SANCIONES.",
  },
  {
    id: 3,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "ENE",
    nameDoc: "MODIFICACIÓN DE DOCUMENTOS BÁSICOS FXMT.",
  },
  {
    id: 4,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc:
      "POR EL QUE SE APRUEBA EL PROGRAMA DE IMPARTICIÓN ELABORADO POR LA JUNTA GENERAL EJECUTIVA.",
    titleAnexo1:
      "PROGRAMA DE IMPARTICIÓN DE SEMINARIOS, CONFERENCIAS, COLOQUIOS, DIPLOMADOS, MESAS REDONDAS, DIVULGACIÓN DE TEXTOS, PUBLICACIONES DE RESULTADOS DE INVESTIGACIÓN Y PRESENTACIÓN DE LIBROS 2025.",
  },
  {
    id: 5,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "ENE",
    nameDoc: "DENTRO DEL POS CON NÚMERO DE EXPEDIENTE CQD/Q/IML/CG/076/2024.",
  },
  {
    id: 6,
    typeDoc: " ACUERDO ",
    monthDoc: "FEB",
    nameDoc:
      "POR EL QUE SE REFORMA EL REGLAMENTO DE SESIONES DEL CONSEJO GENERAL DEL ITE.",
    titleAnexo1: "REGLAMENTO DE SESIONES DEL CG DEL ITE",
  },
  {
    id: 7,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc:
      "POR EL QUE SE APRUEBA EL PROYECTO DE PRESUPUESTO PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1: "AMPLIACION PRESUPUESTAL",
  },
  {
    id: 8,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc:
      "POR EL SE APRUEBA EL CALENDARIO ELECTORAL LEGAL PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1: "CALENDARIO ELECTORAL LEGAL  ",
  },
  {
    id: 9,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc:
      "POR EL QUE SE APRUEBAN LOS LINEAMIENTOS DE DESIGNACIÓN DE PERSONAS INTEGRANTES DE CD PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024 2025.",
    titleAnexo1: "MANIFESTACIÓN DE INTENCIÓN",
    titleAnexo2: "SOLICITUD DE REGISTRO",
    titleAnexo3: "RESUMEN CURRICULAR",
    titleAnexo4: "DECLARACIÓN BAJO PROTESTA DE DECIR VERDAD",
    titleAnexo5: "DECLARACIÓN ART 38",
    titleAnexo6: "LINEAMIENTOS CD PELEPJ",
    titleAnexo7: "FE DE ERRATAS",
  },
  {
    id: 10,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc:
      "POR EL QUE SE APRUEBA LA ESTRATEGIA DE RECLUTAMIENTO DE SEL Y CAEL PELEPJ 2024-2025.",
    titleAnexo1: "ESTRATEGIA RECLUTAMIENTO DE SEL Y CAEL PELEPJ",
  },
  {
    id: 11,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc:
      "POR EL QUE SE DETERMINAN LOS CRITERIOS PARA GARANTIZAR EL PRINCIPIO CONSTITUCIONAL DE PARIDAD DE GÉNERO EN EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 12,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "FEB",
    nameDoc:
      "RELATIVA AL DICTADO DE MEDIDAS CAUTELARES, EMITIDA POR EL CONSEJO GENERAL DEL ITE, DENTRO DEL PROCEDIMIENTO ESPECIAL SANCIONADOR CQD/CA/CG/001/2025.",
  },
  {
    id: 13,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "FEB",
    nameDoc:
      "RELATIVA AL DICTADO DE MEDIDAS CAUTELARES, EMITIDA POR EL CONSEJO GENERAL DEL ITE, DENTRO DEL PROCEDIMIENTO ESPECIAL SANCIONADOR CQD/CA/CG/002/2025.",
  },
  {
    id: 14,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "FEB",
    nameDoc:
      "DICTADA POR EL CONSEJO GENERAL DEL ITE, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/FXMT/CG/077/2024.",
  },
  {
    id: 15,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc:
      "POR EL QUE SE APRUEBA EL DICTAMEN GENERAL DE RESULTADOS DE LA EVALUACIÓN DESEMPEÑO SPEN.",
    titleAnexo1:
      "DICTAMEN GENERAL DE RESULTADOS DE LA EVALUACIÓN DEL DESEMPEÑO DEL PERSONAL DEL SPEN DEL SISTEMA DE LOS ORGANISMOS PÚBLICOS LOCALES ELECTORALES.",
  },
  {
    id: 16,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc:
      "POR EL QUE SE APRUEBA LA METODOLOGíA, PARA LA DIFUSIÓN Y  PROMOCIÓN DE LA PARTICIPACIÓN CIUDADANA PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024 2025.",
    titleAnexo1:
      "METODOLOGÍA PARA LA DIFUSIÓN Y PROMOCIÓN DE LA PARTICIPACIÓN CIUDADANA EN EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024 2025.",
  },
  {
    id: 17,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc:
      "POR EL QUE SE APRUEBA EL PROGRAMA OPERATIVO DE LA RED DE MUJERES JUZGADORAS CANDIDATAS Y ELECTAS PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1:
      "PROGRAMA OPERATIVO DE LA RED DE MUJERES JUZGADORAS  CANDIDATAS Y ELECTAS PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo2: "FE DE ERRATAS ACUERDO ITE-CG 17-2025",
  },
  {
    id: 18,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBAN LOS LINEAMIENTOS PARA LA RECEPCIÓN, RESGUARDO, REVISIÓN Y TRATAMIENTO  DE LOS LISTADOS Y RECEPCIÓN, RESGUARDO, REVISIÓN, TRATAMIENTO Y DEVOLUCIÓN DE LOS EXPEDIENTES REMITIDOS AL INSTITUTO POR EL CONGRESO DEL ESTADO DE TLAXCALA",
    titleAnexo1: "VOTO PARTICULAR",
    titleAnexo2: "VOTO CONCURRENTE",
    titleAnexo3: "LINEAMIENTOS REVISIÓN Y TRATAMIENTO EXPEDIENTES",
    titleAnexo4: "ACUSE DE RECIBO EXP DIGITAL PEEPJL",
  },
  {
    id: 19,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBA LA CONTRATACIÓN DE UN TERCERO ESPECIALIZADO PARA EL DISEÑO, DESARROLLO, IMPLEMENTACIÓN Y OPERACIÓN DEL SISTEMA INFORMÁTICO DE CÓMPUTOS PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 20,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBAN LOS LINEAMIENTOS PARA FOROS DE DEBATE ORGANIZADOS POR EL ITE Y, DE LAS ENTREVISTAS Y FOROS DE DEBATE PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1: "LINEAMIENTOS PARA FOROS DE DEBATE ORGANIZADOS POR EL ITE",
  },
  {
    id: 21,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBAN LAS METODOLOGÍAS PARA LOS DISTINTOS MONITOREOS Y EL CATÁLOGO DE MEDIOS DE COMUNICACIÓN IMPRESOS, DIGITALES Y DE RADIO Y TELEVISIÓN A MONITOREAR EN EL PELEPJ 2024-2025.",
    titleAnexo1: "METODOLOGÍA MONITOREO CONTRATACIÓN DE ESPACIOS PUBLICITARIOS",
    titleAnexo2: "METODOLOGÍA MONITOREO PERSPECTIVA DE GÉNERO",
    titleAnexo3: "CATÁLOGO DE MEDIOS DE COMUNICACIÓN",
  },
  {
    id: 22,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBAN LOS LINEAMIENTOS DE ASIGNACIÓN DE CARGOS PELEPJ 2024-2025.",
    titleAnexo1: "LINEAMIENTOS ASIGNACIÓN CARGOS PELEPJ 2024-2025.",
  },
  {
    id: 23,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL SE APRUEBAN LOS DICTÁMENES QUE EMITEN LA COMISIÓN DE ORGANIZACIÓN ELECTORAL, CAPACITACIÓN, EDUCACIÓN CÍVICA Y LA COMISIÓN TEMPORAL DE DOCUMENTACIÓN ELECTORAL PARA EL PROCESO ELECTORAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1: "DICTAMEN MATERIALES PELEPJ 2024-2025.",
    titleAnexo2:
      "DICTAMEN POR EL QUE SE APRUEBA EL INFORME SOBRE EL DISEÑO Y MODELOS DEFINITIVOS DE DOCUMENTACIÓN ELECTORAL PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo3: "INFORME DE DOCUMENTACIÓN Y MATERIALES PEEPJ 2025.",
  },
  {
    id: 24,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBAN LOS LINEAMIENTOS PARA EL USO DEL SISTEMA CANDIDATAS Y CANDIDATOS, “CONÓCELES” Y DE SU VERSIÓN EJECUTIVA DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1:
      "LINEAMIENTOS PARA EL USO DEL SISTEMA CANDIDATAS Y CANDIDATOS, “CONÓCELES”.",
  },
  {
    id: 25,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE DA RESPUESTA AL ESCRITO PRESENTADO POR LA REPRESENTANTE PROPIETARIA DEL PARTIDO DEL TRABAJO, ANTE ESTE CONSEJO GENERAL.",
  },
  {
    id: 26,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL, RESPECTO DE LA MODIFICACIÓN A LOS DOCUMENTOS BÁSICOS DEL PARTIDO POLÍTICO LOCAL REDES SOCIALES PROGRESISTAS TLAXCALA.",
  },
  {
    id: 27,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBA LA CONVOCATORIA PERMANENTE PARA PARTICIPAR COMO CAPACITADOR/A ASISTENTE ELECTORAL LOCAL EN EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.  ",
    titleAnexo1: "CONVOCATORIA CAEL PELEPJ 2024-2025",
  },
  {
    id: 28,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE READECÚA EL PRESUPUESTO DE EGRESOS DEL EJERCICIO FISCAL DOS MIL VEINTICINCO DE ESTE INSTITUTO.",
    titleAnexo1: "AMPLIACIÓN PRESUPUESTAL 2025",
  },
  {
    id: 29,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBA LA INTEGRACIÓN DE LOS CONSEJOS DISTRITALES ELECTORALES PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1:
      "INTEGRACIÓN DE LOS CONSEJOS DISTRITALES PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo2:
      "LISTA DE RESERVA DE MUJERES PARA LOS CONSEJOS DISTRITALES ELECTORALES PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },

  {
    id: 30,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE LAS MULTAS PREVISTAS EN LAS RESOLUCIONES INE/CG302/2021, INE/CG1401/2021, INE/CG258/2024 E INE/CG2459/2024.",
    titleAnexo1: "CALENDARIZADO DE SANCIONES.",
  },
  {
    id: 31,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE REFORMA EL REGLAMENTO DE LOS CONSEJOS DISTRITALES Y MUNICIPALES ELECTORALES DEL INSTITUTO TLAXCALTECA DE ELECCIONES.",
    titleAnexo1:
      "REGLAMENTO DE LOS CONSEJOS DISTRITALES Y MUNICIPALES ELECTORALES DEL ITE.",
  },
  {
    id: 32,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBA EL PROTOCOLO PARA LA DETECCIÓN RECOLECCIÓN, ENTREGA E INTERCAMBIO DE PAQUETES, DOCUMENTACIÓN Y MATERIALES ELECTORALES RECIBIDOS EN UN ÓRGANO ELECTORAL DISTINTO AL COMPETENTE, PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025. ",
    titleAnexo1: "PROTOCOLO ENTREGA DE PAQUETES INE-ITE.",
  },
  {
    id: 33,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE APRUEBA LA DESIGNACIÓN DE LOS LUGARES QUE OCUPARÁN LAS BODEGAS ELECTORALES, EL PERSONAL AUTORIZADO, ASÍ COMO A LA PERSONA RESPONSABLE DE LLEVAR EL CONTROL PRECISO SOBRE LA ASIGNACIÓN DE FOLIOS DE LAS BOLETAS ELECTORALES DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1: "ESPACIOS DE BODEGAS.",
    titleAnexo2:
      "PERSONAL AUTORIZADO PARA EL ACCESO A LAS BODEGAS ELECTORALES.",
  },
  {
    id: 34,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL QUE SE DETERMINAN LOS TOPES MÁXIMOS DE GASTOS PERSONALES DE CAMPAÑA DE LAS PERSONAS CANDIDATAS EN EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 35,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc:
      "POR EL CUAL SE APRUEBAN LAS REGLAS GENERALES PARA EL TRAMITE DE LOS PROCEDIMIENTOS SANCIONADORES EN EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1:
      "REGLAS GENERALES PARA EL TRAMITE DE LOS PROCEDIMIENTOS SANCIONADORES EN EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 36,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      "POR EL QUE SE APRUEBAN LAS MEDIDAS DE SEGURIDAD QUE CONTENDRÁN LAS BOLETAS ELECTORALES, ASÍ COMO LA DETERMINACIÓN DE LA FECHA LÍMITE EN LA QUE SE PODRÁN MODIFICAR LAS BOLETAS ELECTORALES A UTILIZARSE EN LA JORNADA ELECTORAL DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 37,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      "POR EL QUE SE APRUEBA LA SELECCIÓN DE TEMAS PARA LOS FOROS DE DEBATES ORGANIZADOS POR EL ITE EN EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 38,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "ABR",
    nameDoc: "PROCEDIMIENTO ORDINARIO SANCIONADOR CQD-Q-PVEM-CG-011-2024",
  },
  {
    id: 39,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      "POR EL SE APRUEBAN LOS LINEAMIENTOS PARA REGULAR EL DESARROLLO DE LOS CÓMPUTOS ELECTORALES, ASÍ COMO EL CUADERNILLO DE CONSULTA DE VOTOS VÁLIDOS Y VOTOS NULOS PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1:
      "LINEAMIENTOS PARA REGULAR EL DESARROLLO DE LOS CÓMPUTOS ELECTORALES DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo2:
      "CUADERNILLO DE CONSULTA DE VOTOS VÁLIDOS Y VOTOS NULOS DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo3:
      "FE DE ERRATAS DEL ACUERDO DEL CONSEJO GENERAL DEL ITE, POR EL QUE SE APRUEBAN LOS LINEAMIENTOS PARA REGULAR EL DESARROLLO DE LOS CÓMPUTOS ELECTORALES, ASÍ COMO EL CUADERNILLO DE CONSULTA DE VOTOS VÁLIDOS Y VOTOS NULOS, AMBOS PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 40,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      "POR EL QUE SE APRUEBA EL DICTAMEN QUE EMITE LA COMISIÓN TEMPORAL DE DOCUMENTACIÓN ELECTORAL PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024 2025",
    titleAnexo1:
      "DICTAMEN QUE EMITE LA COMISIÓN TEMPORAL DE DOCUMENTACIÓN ELECTORAL PARA EL PROCESO ELECTORAL EXTRAORDINARIO 2024- 2025.",
    titleAnexo2:
      "INFORME SOBRE EL DISEÑO Y MODELOS DEFINITIVOS DE DOCUMENTACIÓN Y MATERIALES ELECTORALES PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024- 2025.",
    titleAnexo3:
      "DISEÑOS DE LA DOCUMENTACIÓN ELECTORAL DE CONSEJOS PARA EL PROCESO ELECTORAL EXTRAORDINARIO 2024-2025.",
  },

  {
    id: 41,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      "POR EL QUE SE APRUEBAN LOS LINEAMIENTOS PARA LA FISCALIZACIÓN DE LAS ORGANIZACIONES QUE REALICEN OBSERVACIÓN ELECTORAL LOCAL EN LOS PROCESOS ELECTORALES DEL PODER JUDICIAL Y DE LOS TRIBUNALES DE JUSTICIA ADMINISTRATIVA Y DE CONCILIACIÓN Y ARBITRAJE.",
    titleAnexo1:
      "LINEAMIENTOS PARA LA FISCALIZACIÓN DE LAS ORGANIZACIONES QUE REALICEN OBSERVACIÓN ELECTORAL LOCAL EN LOS PROCESOS ELECTORALES DEL PODER JUDICIAL Y DE LOS TRIBUNALES DE JUSTICIA ADMINISTRATIVA Y DE CONCILIACIÓN Y ARBITRAJE.",
  },

  {
    id: 42,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      " POR EL QUE SE APRUEBA EL PROTOCOLO DE ACTUACIÓN PARA LA ATENCIÓN DE VIOLENCIA POLÍTICA CONTRA LAS MUJERES EN RAZÓN DE GÉNERO.",
    titleAnexo1:
      "PROTOCOLO DE ACTUACIÓN PARA LA ATENCIÓN DE VIOLENCIA POLÍTICA CONTRA LAS MUJERES EN RAZÓN DE GÉNERO.",
  },

  {
    id: 43,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      "POR EL SE APRUEBA LA MODIFICACIÓN AL PROGRAMA DE INCENTIVOS PARA EL PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL DEL ITE.",
    titleAnexo1:
      "PROGRAMA DE INCENTIVOS PARA EL PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL ",
  },
  {
    id: 44,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      "POR EL QUE SE APRUEBA LA CREACIÓN DE LA COORDINACIÓN DE RECURSOS FINANCIEROS ADSCRITA A LA DIRECCIÓN DE PRERROGATIVAS, ADMINISTRACIÓN Y FISCALIZACIÓN Y SE REFORMA EL REGLAMENTO INTERIOR DEL ITE.",
    titleAnexo1: "VOTO PARTICULAR CONSEJERO ELECTORAL HERMENEGILDO NERIA.",
    titleAnexo2: "VOTO PARTICULAR CONSEJERA ELECTORAL YEDITH MARTINEZ.",
    titleAnexo3: "VOTO PARTICULAR CONSEJERA ELECTORAL JANET CERVANTES.",
    titleAnexo4: "REGLAMENTO INTERIOR DEL INSTITUTO TLAXCALTECA DE ELECCIONES.",
  },
  {
    id: 45,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE LAS MULTAS PREVISTAS EN LAS RESOLUCIONES INE/CG80/2025, INE/CG81/2025, INE/CG83/2025, INE/CG85/2025, INE/CG86/2025 E INE/CG87/2025.",
    titleAnexo1: "CALENDARIZADO SANCIONES",
  },
  {
    id: 46,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "ABR",
    nameDoc:
      "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CON NÚMERO DE EXPEDIENTE CQD/Q/VGGM/CG/075/2024 Y SU ACUMULADO CQD/Q/JAT/CG/081/2024.",
    titleAnexo1: "",
  },
  {
    id: 47,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc:
      "POR EL QUE SE DETERMINA LA FECHA, HORA DE INICIO Y CIERRE DE PUBLICACIÓN, LA ACTUALIZACIÓN DE DATOS, IMÁGENES Y BASE DE DATOS, ASÍ COMO LA CONVOCATORIA PARA PARTICIPAR COMO DIFUSORES OFICIALES; TODO RELACIONADO CON EL SISTEMA INFORMÁTICO DE CÓMPUTOS, PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025. ",
    titleAnexo1:
      "CONVOCATORIA PARA PARTICIPAR COMO DIFUSORES OFICIALES DE LOS RESULTADOS DEL SISTEMA INFORMÁTICO DE CÓMPUTOS PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo2: "CARTA COMPROMISO.",
    titleAnexo3:
      "CARTA INTENCIÓN DIFUSOR OFICIAL DEL SISTEMA DE COMPUTOS DEL PELEPJ 2024 - 2025.",
  },
  {
    id: 48,
    typeDoc: "ACUERDO",
    monthDoc: "MAY",
    nameDoc:
      "POR EL QUE SE DESIGNA AL PERSONAL AUTORIZADO PARA EL CONTEO, SELLADO Y AGRUPAMIENTO DE LAS BOLETAS ELECTORALES, PARA LA INTEGRACIÓN DE LA DOCUMENTACIÓN DENTRO DE LOS PAQUETES ELECTORALES PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1: "LISTADO DEL PERSONAL PARA EL SELLADO.",
  },
  {
    id: 49,
    typeDoc: "RESOLUCÍON",
    monthDoc: "MAY",
    nameDoc:
      "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS DOCUMENTOS BÁSICOS DEL PARTIDO POLÍTICO REDES SOCIALES PROGRESISTAS TLAXCALA.",
  },
  {
    id: 50,
    typeDoc: "ACUERDO",
    monthDoc: "MAY",
    nameDoc:
      "POR EL QUE SE MODIFICAN LOS LINEAMIENTOS PARA REGULAR EL DESARROLLO DE LOS CÓMPUTOS ELECTORALES Y EL CUADERNILLO DE CONSULTA DE VOTOS VÁLIDOS Y VOTOS NULOS, ASÍ COMO LOS LINEAMIENTOS PARA EL USO DEL SISTEMA CANDIDATAS Y CANDIDATOS, “CONÓCELES” Y SU VERSIÓN EJECUTIVA, DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1:
      "LINEAMIENTOS PARA REGULAR EL DESARROLLO DE LOS CÓMPUTOS ELECTORALES DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo2:
      "CUADERNILLO DE CONSULTA DE VOTOS VÁLIDOS Y VOTOS NULOS DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo3:
      "LINEAMIENTOS PARA EL USO DEL SISTEMA CANDIDATAS Y CANDIDATOS, “CONÓCELES” Y DE SU VERSIÓN EJECUTIVA DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 51,
    typeDoc: "ACUERDO",
    monthDoc: "MAY",
    nameDoc:
      "POR EL QUE SE APRUEBA EL PROCEDIMIENTO PARA LA VERIFICACIÓN DE LOS REQUISITOS ESTABLECIDOS EN EL ARTÍCULO 21 DE LOS LINEAMIENTOS PARA LA ASIGNACIÓN DE CARGOS EN EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 52,
    typeDoc: "ACUERDO",
    monthDoc: "MAY",
    nameDoc:
      "POR EL QUE SE APRUEBAN LOS PROCEDIMIENTOS DE SELECCIÓN DELAS CASILLAS SECCIONALES ÚNICAS Y DE VERIFICACIÓN DE LAS MEDIDAS DE SEGURIDAD CONTENIDAS EN LAS BOLETAS ELECTORALES A UTILIZARSE EN LA JORNADA ELECTORAL DEL PRIMERO DE JUNIO DE DOS MIL VEINTICINCO DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1:
      "SELECCIÓN DE CASILLAS PARA LA VERIFICACIÓN DE LAS MEDIDAS DE SEGURIDAD CONTENIDAS EN LAS BOLETAS ELECTORALES A UTILIZARSE EN LA JORNADA ELECTORAL DEL 1 DE JUNIO DEL 2025, DENTRO DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo2:
      "PROCEDIMIENTO PARA LA VERIFICACIÓN DE LAS MEDIDAS DE SEGURIDAD CONTENIDAS EN LAS BOLETAS ELECTORALES A UTILIZARSE EN LA JORNADA ELECTORAL DEL 1 DE JUNIO DEL 2025, DENTRO DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },

  {
    id: 53,
    typeDoc: "ACUERDO",
    monthDoc: "MAY",
    nameDoc:
      "POR EL QUE SE DESIGNA AL PERSONAL QUE AUXILIARÁ EN LA SESIÓN PERMANENTE DE CÓMPUTOS; Y EN LA SESIÓN PERMANENTE PARA EL PROCEDIMIENTO DE SUMATORIA DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    titleAnexo1: "LISTADO DEL PERSONAL.",
  },
  {
    id: 54,
    typeDoc: "ACUERDO",
    monthDoc: "MAY",
    nameDoc:
      "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE LAS MULTAS PREVISTAS EN LA RESOLUCIÓN INE/CG84/2025.",
    titleAnexo1: "ANEXO UNICO ITE-CG 54-2025",
  },

  {
    id: 55,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "MAY",
    nameDoc:
      "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS DOCUMENTOS BÁSICOS DEL PARTIDO DE LA REVOLUCIÓN DEMOCRÁTICA TLAXCALA.",
      titleAnexo1: "FE DE ERRATAS POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS DOCUMENTOS BÁSICOS DEL PARTIDO DE LA REVOLUCIÓN DEMOCRÁTICA TLAXCALA.",
    },

  {
    id: 56,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "MAY",
    nameDoc:
      "DICTADA POR EL CONSEJO GENERAL DEL ITE, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PT/CG/002/2025.",
  },

  {
    id: 57,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "MAY",
    nameDoc:
      "RESOLUCIÓN DEL CONSEJO GENERAL DEL ITE, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CON NÚMERO DE EXPEDIENTE CQD/Q/ALSR/012/2025.",
  },

  {
    id: 58,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "MAY",
    nameDoc:
      "DICTADA POR EL CONSEJO GENERAL DEL ITE, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PNAT/CG/008/2025.",
  },
  {
    id: 59,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "MAY",
    nameDoc:
      "DICTADA POR EL CONSEJO GENERAL DEL ITE, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/RSPT/CG/006/2025.",
  },
  {
    id: 60,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "MAY",
    nameDoc:
      "RELATIVA AL DICTADO DE MEDIDAS CAUTELARES, EMITIDA POR EL CONSEJO GENERAL DEL ITE, DENTRO DEL PROCEDIMIENTO ESPECIAL SANCIONADOR CQD/CA/CG/001/2025.",
  },
  {
    id: 61,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "MAY",
    nameDoc:
      "RELATIVA AL DICTADO DE MEDIDAS CAUTELARES, EMITIDA POR EL CONSEJO GENERAL DEL ITE, DENTRO DEL PROCEDIMIENTO ESPECIAL SANCIONADOR CQD/CA/CG/011/2025.",
  },
  {
    id: 62,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc:
      "POR EL QUE SE APRUEBA LA ASIGNACIÓN DE LOS CARGOS DE MAGISTRATURAS DEL TRIBUNAL SUPERIOR DE JUSTICIA, DERIVADO DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 63,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc:
      "POR EL QUE SE APRUEBA LA ASIGNACIÓN DE LOS CARGOS DE MAGISTRATURAS DEL TRIBUNAL DE DISCIPLINA JUDICIAL, DERIVADO DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 64,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc:
      "POR EL QUE SE APRUEBA LA ASIGNACIÓN DE LOS CARGOS DE MAGISTRATURAS DEL TRIBUNAL DE JUSTICIA ADMINISTRATIVA, DERIVADO DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 65,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc:
      "POR EL QUE SE APRUEBA LA ASIGNACIÓN DE LOS CARGOS DE MAGISTRATURAS DEL TRIBUNAL CONCILIACIÓN Y ARBITRAJE, DERIVADO DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 66,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc:
      "POR EL QUE SE APRUEBA LA ASIGNACIÓN DE LOS CARGOS DE JUEZAS Y JUECES CON ÁMBITO TERRITORIAL ELECTIVO ESTATAL, DERIVADO DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },
  {
    id: 67,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc:
      "POR EL QUE SE APRUEBA LA ASIGNACIÓN DE LOS CARGOS DE JUEZAS Y JUECES CON ÁMBITO TERRITORIAL ELECTIVO DISTRITAL, DERIVADO DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
  },

  {
    id: 68,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc:
      "POR EL QUE SE READECÚA EL PRESUPUESTO DE EGRESOS DEL EJERCICIO FISCAL DOS MIL VEINTICINCO, DE ESTE INSTITUTO.",
    titleAnexo1: "ANEXO UNICO ITE-CG 68-2025. PRESUPUESTO",
  },

  {
    id: 69,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "JUN",
    nameDoc:
      "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO DE LA MODIFICACIÓN DE LOS ESTATUTOS DEL PARTIDO POLÍTICO LOCAL DENOMINADO PARTIDO ALIANZA CIUDADANA.",
  },

  {
    id: 70,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "JUN",
    nameDoc:
      "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO DE LA MODIFICACIÓN DE LOS DOCUMENTOS BÁSICOS DEL PARTIDO POLÍTICO LOCAL FUERZA POR MÉXICO TLAXCALA.",
  },
  {
    id: 71,
    typeDoc: "ACUERDO",
    monthDoc: "JUL",
    nameDoc:
      "POR EL QUE SE ORDENA LA RETENCIÓN DE LAS CANTIDADES POR CONCEPTO DE RETIRO DE PROPAGANDA ELECTORAL A LOS PARTIDOS POLÍTICOS Y CANDIDATURAS INDEPENDIENTES, ASÍ COMO EL PAGO A LOS AYUNTAMIENTOS POR ESTE CONCEPTO, CORRESPONDIENTE AL PROCESO ELECTORAL LOCAL ORDINARIO 2023-2024.",
      titleAnexo1: "ANEXO UNICO ITE-CG 71/2025 INFORME PROPAGANDA PELO 2023-2024",
    },
  {
    id: 72,
    typeDoc: "ACUERDO",
    monthDoc: "JUL",
    nameDoc:
      "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE LAS MULTAS PREVISTAS EN LAS RESOLUCIONES INE/CG2012/2024 DEL INSTITUTO NACIONAL ELECTORAL E ITE-CG 56/2025 DE ESTE INSTITUTO.",
      titleAnexo1: "ANEXO UNICO DEL ACUERDO ITE-CG 72/2025",
    },
  {
    id: 73,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "JUL",
    nameDoc:
      "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS ESTATUTOS DEL PARTIDO POLÍTICO NUEVA ALIANZA TLAXCALA.",
  },
  {
    id: 74,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc:
      "POR EL QUE SE APRUEBAN LAS PONDERACIONES DE LA EVALUACIÓN TRIANUAL DEL DESEMPEÑO DE LAS Y LOS MIEMBROS DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, CORRESPONDIENTE AL CICLO TRIANUAL DE LOS PERIODOS QUE ABARCAN DEL MES DE SEPTIEMBRE 2025 AL MES DE AGOSTO 2026, DEL MES DE SEPTIEMBRE 2026 AL MES DE AGOSTO 2027 Y DEL MES DE SEPTIEMBRE 2027 AL MES DE AGOSTO 2028.",
  },
  {
    id: 75,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "AGO",
    nameDoc:
      "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO DE LA MODIFICACIÓN DE LOS ESTATUTOS DEL PARTIDO POLÍTICO DE LA REVOLUCIÓN DEMOCRÁTICA TLAXCALA.",
  },
  {
    id: 76,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc:
      "MEDIANTE EL CUAL SE INFORMA AL CONGRESO DEL ESTADO DE TLAXCALA LA CANCELACIÓN DE REGISTRO DE CANDIDATURAS DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO PARA RENOVAR LOS CARGOS DEL PODER JUDICIAL, TRIBUNAL DE JUSTICIA ADMINISTRATIVA Y TRIBUNAL DE CONCILIACIÓN Y ARBITRAJE 2024-2025, REALIZADA POR EL CONSEJO GENERAL DEL INSTITUTO NACIONAL ELECTORAL MEDIANTE LA RESOLUCIÓN INE/CG985/2025.",
    titleAnexo1: "ANEXO UNICO DEL ACUERDO ITE-CG 76/2025",
    },
  {
    id: 77,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc:
      "POR EL QUE SE REALIZA LA ASIGNACIÓN DE UNA MAGISTRATURA DEL TRIBUNAL DE DISCIPLINA JUDICIAL CORRESPONDIENTE AL PROCESO ELECTORAL LOCAL EXTRAORDINARIO PARA RENOVAR LOS CARGOS DEL PODER JUDICIAL, TRIBUNAL DE JUSTICIA ADMINISTRATIVA Y TRIBUNAL DE CONCILIACIÓN Y ARBITRAJE 2024-2025, EN CUMPLIMIENTO A LA SENTENCIA DICTADA POR LA SALA SUPERIOR DEL TRIBUNAL ELECTORAL DEL PODER JUDICIAL DE LA FEDERACIÓN DENTRO DEL EXPEDIENTE SUP-JDC-2280/2025",
  },
  {
    id: 78,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc:
      "POR EL QUE SE REALIZA LA ASIGNACIÓN DE UNA MAGISTRATURA DEL TRIBUNAL DE CONCILIACIÓN Y ARBITRAJE CORRESPONDIENTE AL PROCESO ELECTORAL LOCAL EXTRAORDINARIO PARA RENOVAR LOS CARGOS DEL PODER JUDICIAL, TRIBUNAL DE JUSTICIA ADMINISTRATIVA Y TRIBUNAL DE CONCILIACIÓN Y ARBITRAJE 2024-2025",
  },
  {
    id: 79,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "SEP",
    nameDoc:
      "POR LA QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO DE LA MODIFICACIÓN A LOS ESTATUTOS DEL PARTIDO POLÍTICO LOCAL REDES SOCIALES PROGRESISTAS TLAXCALA.",
  },
  {
    id: 80,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "SEP",
    nameDoc:
      "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS ESTATUTOS DEL PARTIDO POLÍTICO LOCAL FUERZA POR MEXICO TLAXCALA.",
  },
  {
    id: 81,
    typeDoc: "ACUERDO",
    monthDoc: "SEP",
    nameDoc:
      "POR EL QUE SE APRUEBA EL PROYECTO DE PRESUPUESTO DE EGRESOS DE ESTE INSTITUTO PARA EL EJERCICIO FISCAL DOS MIL VEINTISÉIS.",
    titleAnexo1: "ANEXO UNO ITE-CG 81-2025",
    titleAnexo2: "ANEXO DOS ITE-CG 81-2025",
    titleAnexo3: "ANEXO TRES ITE-CG 81-2025",
  },
  {
    id: 82,
    typeDoc: "ACUERDO",
    monthDoc: "OCT",
    nameDoc:
      " POR EL QUE SE READECÚA EL PRESUPUESTO DE EGRESOS DEL EJERCICIO FISCAL DOS MIL VEINTICINCO, DE ESTE INSTITUTO.",
      titleAnexo1: "ANEXO UNICO",

  },
  {
    id: 83,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "OCT",
    nameDoc:
      "DICTADO POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PRI/CG/001/2025.",

  },
  {
    id: 84,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "OCT",
    nameDoc:
      "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/MC/CG/003/2025.",

  },
  {
    id: 85,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "OCT",
    nameDoc:
      "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PAC/CG/004/2025.",

  },
  {
    id: 86,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "OCT",
    nameDoc:
      "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PAC/CG/013/2025.",

  },
  {
    id: 87,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "OCT",
    nameDoc:
      "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/FXMT/CG/014/2025.",

  },
  {
    id: 88,
    typeDoc: "ACUERDO",
    monthDoc: "NOV",
    nameDoc:
      "POR EL QUE SE ADECUA LA INTEGRACIÓN DE LAS COMISIONES Y COMITÉS, PARA EL CUMPLIMIENTO DE LOS FINES Y ATRIBUCIONES DEL INSTITUTO.",
  },
  {
    id: 89,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "NOV",
    nameDoc:
      "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO DE LA MODIFICACIÓN DE LOS DOCUMENTOS BÁSICOS DEL PARTIDO POLÍTICO DE LA REVOLUCIÓN DEMOCRÁTICA TLAXCALA.",
  },
  {
    id: 90,
    typeDoc: "ACUERDO",
    monthDoc: "NOV",
    nameDoc:
      "POR EL QUE SE APRUEBA EL DICTAMEN PARA EL OTORGAMIENTO DE INCENTIVOS, A EFECTUAR EN 2025, CORRESPONDIENTE AL EJERCICIO VALORADO 2024 A PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL DE ESTE INSTITUTO.",
      titleAnexo1: "ANEXO UNO ITE-CG 90-2025",
      titleAnexo2: "ANEXO DOS ITE-CG 90-2025",
  },
  {
    id: 91,
    typeDoc: "ACUERDO",
    monthDoc: "NOV",
    nameDoc:
      "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE LAS MULTAS PREVISTAS EN LA RESOLUCIÓN INE/CG377/2025, DEL INSTITUTO NACIONAL ELECTORAL.",
      titleAnexo1: "ANEXO UNICO ITE-CG 91-2025",
  },
  {
    id: 92,
    typeDoc: "ACUERDO",
    monthDoc: "NOV",
    nameDoc:
      "POR EL QUE SE READECÚA EL PRESUPUESTO DE EGRESOS DEL EJERCICIO FISCAL DOS MIL VEINTICINCO, DE ESTE INSTITUTO.",
      titleAnexo1: "ANEXO UNICO ITE-CG 92-2025",
  },
  {
    id: 93,
    typeDoc: "ACUERDO",
    monthDoc: "NOV",
    nameDoc:
      "POR EL QUE SE PRESENTA EL INFORME TÉCNICO DE RESULTADOS DE LA CAPTURA DE INFORMACIÓN EN EL SISTEMA CANDIDATAS Y CANDIDATOS, “CONÓCELES”, DURANTE EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO PARA RENOVAR LOS CARGOS DEL PODER JUDICIAL, TRIBUNAL DE JUSTICIA ADMINISTRATIVA Y TRIBUNAL DE CONCILIACIÓN Y ARBITRAJE 2024-2025.",
      titleAnexo1: "ANEXO UNICO ITE-CG 93-2025",
  },
  {
    id: 94,
    typeDoc: "ACUERDO",
    monthDoc: "NOV",
    nameDoc:
      "POR EL QUE SE ESTABLECE EL PROCEDIMIENTO PARA LA EJECUCIÓN DE LAS MULTAS PREVISTAS EN LA RESOLUCIÓN INE/CG985/2025 DEL INSTITUTO NACIONAL ELECTORAL.",
  },
  {
    id: 95,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "DIC",
    nameDoc:
      "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/RSPT/CG/005/2025.",
  },
  {
    id: 96,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "DIC",
    nameDoc:
      "DEL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS ESTATUTOS DEL PARTIDO POLÍTICO NUEVA ALIANZA TLAXCALA.",
  },
  {
    id: 97,
    typeDoc: "ACUERDO",
    monthDoc: "DIC",
    nameDoc:
      "POR EL QUE SE READECÚA EL PRESUPUESTO DE EGRESOS DEL EJERCICIO FISCAL DOS MIL VEINTICINCO, DE ESTE INSTITUTO.",
      titleAnexo1: "ANEXO UNICO ITE-CG 97-2025",
  },
  {
    id: 98,
    typeDoc: "ACUERDO",
    monthDoc: "DIC",
    nameDoc:
      "POR EL QUE SE ADECÚA EL PRESUPUESTO DE EGRESOS PARA EL EJERCICIO FISCAL DOS MIL VEINTISÉIS DE ESTE INSTITUTO, CON BASE EN LOS MONTOS APROBADOS POR EL CONGRESO DEL ESTADO DE TLAXCALA MEDIANTE DECRETO NÚMERO 245.",
      titleAnexo1: "ANEXO UNICO ITE-CG 98-2025",
  },
  {
    id: 99,
    typeDoc: "ACUERDO",
    monthDoc: "DIC",
    nameDoc:
      "POR EL QUE SE APRUEBA LA DESTRUCCIÓN DE LA DOCUMENTACIÓN ELECTORAL UTILIZADA EN EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO PARA RENOVAR LOS CARGOS DEL PODER JUDICIAL, TRIBUNAL DE JUSTICIA ADMINISTRATIVA Y TRIBUNAL DE CONCILIACIÓN Y ARBITRAJE 2024-2025.",
  },
];

// ------------ A C U E R D O S    I N E ------------
export const dataAcuerdosINE2025 = [
  {
    id: 1,
    typeDoc: "ACUERDO",
    numDoc: "INE/CG325/2025",
    nameDoc:
      "ACUERDO DEL CONSEJO GENERAL DEL INE POR EL QUE SE APRUEBAN LAS CONVOCATORIAS PARA LA SELECCIÓN Y DESIGNACIÓN DE LAS PRESIDENCIAS DE LOS ORGANISMOS PÚBLICOS LOCALES,ASÍ COMO DE LAS CONSEJERÍAS ELECTORALES, Y SE ACTUALIZAN LOS LINEAMIENTOS PARA LA APLICACIÓN Y EVALUACIÓN DEL ENSAYO QUE PRESENTARÁN LAS PERSONAS ASPIRANTES QUE OBTENGAN LA MEJOR PUNTUACIÓN EN EL EXAMEN DE CONOCIMIENTOS, APROBADOS MEDIANTE EL ACUERDO INE/CG1417/2021.",
    titleAnexoPDF1:
      "LINEAMIENTOS PARA LA APLICACIÓN Y EVALUACIÓN DEL ENSAYO QUE PRESENTARÁN LAS Y LOS ASPIRANTES EN LOS PROCESOS DE SELECCIÓN ELECTORALES DE LOS ORGANISMOS PÚBLICOS LOCALES.",
  },
  {
    id: 2,
    typeDoc: "ACUERDO",
    numDoc: "INE/CG1162/2025",
    nameDoc:
      "ACUERDO DEL CONSEJO GENERAL DEL INE RELATIVO A LA DESIGNACIÓN DE LAS PRESIDENCIAS DE LOS ORGANISMOS PÚBLICOS LOCALES DE LAS ENTIDADES DE CAMPECHE, CHIAPAS, COAHUILA Y COLIMA, ASÍ COMO DE LAS CONSEJERÍAS ELECTORALES DE LOS ORGANISMOS PÚBLICOS LOCALES DE LAS ENTIDADES DE AGUASCALIENTES, BAJA CALIFORNIA, CHIHUAHUA, COAHUILA, DURANGO, GUERRERO, HIDALGO, NAYARIT, PUEBLA, QUINTANA ROO, SINALOA, TAMAULIPAS, TLAXCALA Y VERACRUZ",
    },
];
